<div>
  <a href="https://www.telegraph.co.uk/health-fitness/body/perimenopause-speeds-ageing-slow/amp/" target="_blank">
    <img src="./images/p1.svg" alt="The Telegraph" class="i1">
    <q>… the first biomarker to pinpoint the mid-life hormonal shifts that signal perimenopause.</q>
  </a>
  <a href="https://www.dailymail.co.uk/femail/article-9484675/amp/How-anti-age-immune-hint-buy-wellies.html" target="_blank">
    <img src="./images/p2.svg" alt="The Telegraph" class="i2">
    <q>… a good early warning system of common diseases.</q>
  </a>
  <a href="https://www.newsonhealth.co.uk/news/exclusive-menopause-study-launched-by-newson-health-research-education-and-glycanage" target="_blank">
    <img src="./images/p3.svg" alt="My Menopause Doctor" class="i3">
    <q>To have a biological test, which is completely objective, would be transformative for menopause care.</q>
  </a>
</div>

<style>
  div {
    padding-top: 2rem;
    margin-bottom: -4rem;
  }

  a {
    display: flex;
    flex-wrap: wrap;
    text-decoration: none;
    color: inherit;
    padding: 2rem 0;
    font-size: 1.25rem;
  }
  
  a:hover,
  a:focus {
    text-decoration: underline;
  }

  a:not(:last-child) {
    border-bottom: 1px solid rgba(0,0,0,.08);
  }

  img {
    width: auto;
    flex: 0 0 16rem;
    margin-bottom: 1rem;
  }

  .i1 {
    height: 2rem;
  }
  
  .i2 {
    height: 2rem;
  }
  
  .i3 {
    height: 2.5rem;
  }

  q {
    flex: 1 0 26ch;
  }
</style>